import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "./index.css";

import _ from "lodash";

import Loading from "../../common/Loading";
import SellerPOView from "./Components/SellerPOView";

import { getBuyerPOs } from "../../services/api/buyerPO";
import { getCompanyById } from "../../services/api/company";
import { getSellerPOBySellerPOId } from "../../services/api/sellerPO";
import { getBuyerQuoteItems } from "../../services/api/buyerQuoteItem";
import { getSellerReqsByBuyerReqIds } from "../../services/api/sellerReq";
import { getBuyerPOItemsByBuyerPOIds } from "../../services/api/buyerPOItem";
import { getApprovalInstancesByDocNo } from "../../services/api/approvalInstances";
import { getMaterialMasterAndTempMaterialIds } from "../../services/api/materialMaster";
import { getMaterialItemsDataByBuyerReqItemIds } from "../../services/api/buyerReqItem";

import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchApprovals, fetchCompanyCreditPeriods, fetchMaterialBrands, fetchStatus} from "../../services/redux/reducers/commonThunk";
import { searchMaterialMandatoryUseFromStock } from "../../services/api/materialMandatoryUseFromStock";
import { getCompanyCertificates } from "../../services/api/companyCertificates";


const SellerPO = () => {
    const { sellerPOId } = useParams()

    const dispatch = useDispatch()

    const [sellerPO, setSellerPO] = useState([])
    const [sellerPOItems, setSellerPOItems] = useState([])
    const [sellerPIPunch, setSellerPIPunch] = useState([])
    const [sellerPIPunchItems, setSellerPIPunchItems] = useState([])
    const [sellerGRNQCPunch, setSellerGRNQCPunch] = useState([])
    const [buyerQuoteItems, setBuyerQuoteItems] = useState([])
    const [sellerReqs, setSellerReqs] = useState([])
    const [sellerReqItems, setSellerReqItems] = useState([])
    const [buyerPOItems, setBuyerPOItems] = useState([])
    const [sellerReq, setSellerReq] = useState({})
    const [buyerReq, setBuyerReq] = useState({})
    const [nonRoutedSellerPOsInfo, setNonRoutedSellerPOsInfo] = useState([])
    const [materialMandatoryUseFromStock, setMaterialMandatoryUseFromStock] = useState([])
    const [companyCertificates, setCompanyCertificates] = useState([])

    const [pmCompanyBillAddrDetails, setPMCompanyBillAddrDetails] = useState({})
    const [sellerBillAddrDetails, setSellerBillAddrDetails] = useState({})
    const [documentHTML, setDocumentHTML] = useState('')
    const [sellerPOPdfURL, setSellerPOPdfURL] = useState('')
    const [approvalInstances, setApprovalInstances] = useState([])
    const [sellerCompanyDetails, setSellerCompanyDetails] = useState({})

    const [materialDetails, setMaterialDetails] = useState([])
    const [sellerShipAddrDetails, setSellerShipAddrDetails] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const companyCreditPeriods = useSelector((state) => state.common.companyCreditPeriods)
    const materialBrands = useSelector(state => state.common.materialBrands)
    const statusData = useSelector((state) => state.common.status)

    useEffect(() => {
        dispatch(fetchCompanyCreditPeriods())
        dispatch(fetchMaterialBrands())
        dispatch(fetchApprovals())
        dispatch(fetchStatus())
    }, [])

    useEffect(() => {
        if(companyCreditPeriods.length > 0 && materialBrands.length > 0 && statusData.length > 0){
            if(!sellerPO.sellerPOId){
                getSellerPO()
            }
        }
    }, [companyCreditPeriods, materialBrands, statusData])

    const getSellerPO = async () => {
        setIsLoading(true)

        const response = await getSellerPOBySellerPOId(sellerPOId, true)
        if (response.failure){
            dispatch(raiseToast({severity:'error', detail: response.data.error, summary:'Seller PO is Not Fetched.', life: 3000}))
        }
        else {
            let newSellerPO = response?.data.sellerPO
            const newSellerPOItems = response?.data.sellerPOItems
            const newSellerPIPunch = response?.data.sellerPIPunch
            const newSellerPIPunchItems = response?.data.sellerPIPunchItems
            const newSellerGRNQCPunch = response?.data.sellerGRNQCPunch

            let buyerReqItemIds = []
            let materialIds = []
            newSellerPOItems?.map(eachSellerPOItem => buyerReqItemIds.push(eachSellerPOItem?.buyerReqItemId))
            newSellerPOItems?.map(eachSellerPOItem => materialIds.push(eachSellerPOItem?.materialId))
            let data = { buyerReqItemsIds : buyerReqItemIds }

            let materialDetailsRes = null
            if (newSellerPO?.expenseCategoryId){
                materialDetailsRes = await getMaterialMasterAndTempMaterialIds({materialIds: materialIds})
            }else{
                materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds(data)
            }

            if (materialDetailsRes.failure){
                dispatch(raiseToast({severity:'error', detail: materialDetailsRes.data.error, summary:'Material Details Not Fetched.', life: 3000}))
            }else {
                setMaterialDetails(materialDetailsRes?.data)
            }    

            const approvalInstanceRes = await getApprovalInstancesByDocNo({ docNo: response?.data.sellerPO.docNo })
            if (approvalInstanceRes.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Approval instances', detail: approvalInstanceRes.data.error, life: 3000 }))
            }

            const sellerComapanyDetails = await getCompanyById(newSellerPO.companyId)
            if (sellerComapanyDetails.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Seller Company Details', detail: sellerComapanyDetails.data.error, life: 3000 }))
            }
            setSellerCompanyDetails(sellerComapanyDetails?.data)

            let buyerQuoteItemRes 
            let buyerPOItemsRes
            let pastSellerPOsRes
            let sellerReqsRes
            let materialMandatoryUseFromStockRes
            if (!newSellerPO?.expenseCategoryId){
                const buyerPORes = await getBuyerPOs({buyerPOIds: [newSellerPO?.buyerPOId], statusIds: [3, 4], permCheckNotRequired: true})
                if (buyerPORes?.failure){
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'error', summary: 'Buyer PO', detail: buyerPORes.data.error, life: 3000 }))
                }

                buyerPOItemsRes = await getBuyerPOItemsByBuyerPOIds([newSellerPO?.buyerPOId])
                if (buyerPOItemsRes?.failure){
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'error', summary: 'Buyer PO Items', detail: buyerPOItemsRes.data.error, life: 3000 }))
                }
                
                buyerQuoteItemRes = await getBuyerQuoteItems({buyerQuoteIds: [buyerPORes?.data?.data[0]?.buyerQuoteId], paginator: false})
                if (buyerQuoteItemRes?.failure){
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'error', summary: 'Buyer Quote Items', detail: buyerQuoteItemRes.data.error, life: 3000 }))
                }
        
                sellerReqsRes = await getSellerReqsByBuyerReqIds({buyerReqIds: [newSellerPO.buyerReqId], isItemsRequired: true})
                if (sellerReqsRes.failure){
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'error', summary: 'Seller Req', detail: sellerReqsRes.data.error }))
                }

                materialMandatoryUseFromStockRes = await searchMaterialMandatoryUseFromStock({materialIds, paginator: false})
                if(materialMandatoryUseFromStockRes.failure){
                    return dispatch(raiseToast({severity:'error', summary:'Mandatory material use from stock',  detail: materialMandatoryUseFromStockRes.data.error, life: 3000}))
                }

                setMaterialMandatoryUseFromStock(materialMandatoryUseFromStockRes.data.data)


                const companyIds = sellerReqsRes.data.sellerReqs.map(eachSellerReq => eachSellerReq.companyId)
                const brandIds = materialDetailsRes.data.map(eachMaterial => eachMaterial.brandId)
                const companyCertificatesRes = await getCompanyCertificates({companyIds: companyIds, entityIds: brandIds, entityType: 'Brand'})

                if (companyCertificatesRes.failure){
                    return dispatch(raiseToast({ severity: 'error', summary: "Company Certificates", details: companyCertificatesRes.data.error, life: 3000 }))
                }

                setCompanyCertificates(companyCertificatesRes.data.data)
            }

            if(sellerReqsRes){
                setSellerReqs(sellerReqsRes.data.sellerReqs)
                setSellerReqItems(sellerReqsRes.data.sellerReqItems)

                let relatedPOSellerReq = sellerReqsRes.data.sellerReqs.map(eachSellerReq => eachSellerReq.sellerReqId === newSellerPO.sellerReqId)
                setSellerReq(relatedPOSellerReq)
            }

            setBuyerReq(response.data.buyerReq)
            setSellerPO(newSellerPO)
            setSellerPOItems(newSellerPOItems)
            setSellerPIPunch(newSellerPIPunch)
            setSellerPIPunchItems(newSellerPIPunchItems)
            setSellerGRNQCPunch(newSellerGRNQCPunch)
            setApprovalInstances(approvalInstanceRes.data)
            
            setBuyerQuoteItems(buyerQuoteItemRes?.data?.data)
            setBuyerPOItems(buyerPOItemsRes?.data)
            setPMCompanyBillAddrDetails(response?.data?.pmCompanyBillAddrDetails)
            setSellerBillAddrDetails(response?.data?.sellerBillAddrDetails)
            setSellerPOPdfURL(response?.data?.sellerPOPdfURL)
            setDocumentHTML(response?.data?.documentHTML)
            setSellerShipAddrDetails(response?.data?.sellerShipAddrDetails)
            setNonRoutedSellerPOsInfo(response.data.nonRoutedSellerPOsInfo)

            setIsLoading(false)
        }
    }

    const relatedNonRoutedSellerPOsInfo = nonRoutedSellerPOsInfo.find(eachNonRoutedSellerPO => eachNonRoutedSellerPO.companyId === sellerPO.companyId && eachNonRoutedSellerPO.docNo === sellerPO.docNo)
    
    return (
        <>
            <div style={{ display: "flex", flexDirection: "column",lineHeight: "1.5", height: "auto"}} className="md:align-items-center p-0 md:px-3 md:pt-0 md:pb-3">
                { sellerPO.sellerPOId && sellerCompanyDetails? 
                    <SellerPOView 
                        displayTable={false}
                        sellerPOId={sellerPOId}
                        sellerPO={sellerPO}
                        sellerPOItems={sellerPOItems}
                        sellerReqs={sellerReqs}
                        sellerReqItems={sellerReqItems}
                        sellerPIPunch={sellerPIPunch}
                        sellerPIPunchItems={sellerPIPunchItems}
                        sellerReq={sellerReq}
                        buyerQuoteItems={buyerQuoteItems}
                        buyerPOItems={buyerPOItems}
                        materialDetails={materialDetails}
                        sellerCompanyDetails={sellerCompanyDetails}
                        pmCompanyBillAddrDetails={pmCompanyBillAddrDetails}
                        sellerBillAddrDetails={sellerBillAddrDetails}
                        sellerShipAddrDetails={sellerShipAddrDetails}
                        documentHTML={documentHTML}
                        getSellerPO={getSellerPO}
                        setDocumentHTML={setDocumentHTML}
                        sellerPOPdfURL={sellerPOPdfURL}
                        setSellerPOPdfURL={setSellerPOPdfURL}
                        approvalInstances={approvalInstances}
                        setApprovalInstances={setApprovalInstances}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        selectedReq={buyerReq}
                        nonRoutedSellerPOsInfo={relatedNonRoutedSellerPOsInfo}
                        buyerReq={buyerReq}
                        setSellerPO={setSellerPO}
                        materialMandatoryUseFromStock={materialMandatoryUseFromStock}
                        companyCertificates={companyCertificates}
                    /> : null
                }
                <Loading visible={isLoading}/>
            </div>
        </>
    )
}

export default SellerPO;